import { createContext } from "react";

export const FormDataContext = createContext({
    files: {},
    data: {},
});

export default FormDataContext;
